import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import Hero from '../../components/pages/MarketDetails/Hero/Hero';
import GlobalCompanies from '../../components/pages/MarketDetails/GlobalCompanies/GlobalCompanies';
import MarketSegments from '../../components/pages/MarketDetails/MarketSegments/MarketSegments';
import FeaturedCompanies from '../../components/pages/MarketDetails/FeaturedCompanies/FeaturedCompanies';
import MarketAccess from '../../components/pages/MarketDetails/MarketAccess/MarketAccess';
import Risk from '../../components/pages/MarketDetails/Risk/Risk';
import Start from '../../components/pages/MarketDetails/Start/Start';
import { useMarketDetailContent } from '../../hooks/useMarketDetailContent';
import { getMarketBySlug } from '../../data/markets';

const MarketDetails = () => {
  const { slug } = useParams();
  const market = getMarketBySlug(slug);
  const { content, isLoading } = useMarketDetailContent(slug, market);

  if (!market) {
    return <Navigate to="/markets/equities" replace />;
  }

  if (isLoading || !content) {
    return null;
  }

  return (
    <div>
      <Hero {...content.hero} />
      <GlobalCompanies {...content.globalCompanies} />
      <MarketSegments {...content.marketSegments} />
      <FeaturedCompanies {...content.featuredCompanies} />
      <MarketAccess {...content.marketAccess} />
      <Risk {...content.risk} />
      <Start {...content.start} />
    </div>
  );
};

export default MarketDetails;
